export enum RetailDataReportFields {
  Date = 'date',
  ReportType = 'reportType',
}
